import { useContext, useEffect, useMemo } from 'react'
import { segmentMap } from './useOnboardingSteps'
import { OnboardingContext } from '../context/onboarding/OnboardingContext'
import { StepSegment } from '../types'

export default function useSegmentConfig({ name, path }: any) {
	const { setActive, setCanStepForward, setCanSkipStep, useOnboardingState } =
		useContext(OnboardingContext)

	const {
		name: segmentName,
		sectionIndex,
		segmentIndex,
		...rest
	}: any = useMemo(() => {
		return name
			? segmentMap[name]
			: Object.values(segmentMap).find((segment: StepSegment) => segment.slug === path)
	}, [name, path])

	const state: any = useOnboardingState()
	const completed = useMemo(
		() => state?.completedSegments?.includes(segmentName),
		[state?.completedSegments]
	)

	useEffect(() => {
		// setCanStepForward(completed)
		return () => setCanStepForward(false)
	}, [])

	useEffect(() => {
		if (state?.activeSection !== sectionIndex || state?.activeSegment !== segmentIndex) {
			setActive({ sectionIndex, segmentIndex })
		}
	}, [sectionIndex, segmentIndex, state?.activeSection, state?.activeSegment])

	useEffect(() => {
		setCanSkipStep(completed)
		return () => {
			setCanSkipStep(false)
		}
	}, [])

	return {
		state,
		segmentName,
		sectionIndex,
		segmentIndex,
		setCanStepForward,
		completed,
		...rest
	}
}
